/**
 * クラス名：材料名称一覧画面
 * 説明：iQ3板金に使用の材料名称一覧ファイルです。
 * 作成者：テッ
 * 作成日：2023/06/01
 * バージョン：1.0
 */

import { Table, Form, Button, Row, Input, Col, Modal, Select, Space, Image, Radio, InputNumber } from 'antd';
import { Table as RTable } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import { CSVLink, CSVDownload } from 'react-csv';
import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { CloseOutlined, SyncOutlined } from '@ant-design/icons';
import SplitPane, { Pane } from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';
import { StatusCodes } from 'http-status-codes';

import '../../../../assets/styles/common.css';
import checked from '../../../../assets/images/checked.png';
import {
  confirmHakiContent,
  confirmModalTitle,
  commonModal,
  commonFooter,
  confirmDiscardContent,
  modalTitle,
  confirmDeleteContent,
  confirmCreateContent,
  commonActionFooter,
  confirmUpdateContent,
  authorizeError,
  error,
  commonDeleteFooter,
  commonResponsiveConfirmModal,
  BulkDeleteModal,
  bulkDeleteModalTitle,
  complete,
  deleteModalTitle,
  commonDeleteAllFooter,
} from '../../../common/CommonModal';
import {
  JPYs,
  getZaishittsuNameDDL,
  dataStateList,
  actionArr,
  getMaterialNameStorage,
  ResizableTitle,
  formatDate,
  getMaterialTypeIQ3List,
  defaultValue,
  getAccessToken,
  updateAccessToken,
  formValidatorMode,
  handleKeyPress,
  regexExp,
  toHalfWidth,
  formatDateString,
  todayTime,
  isDecimal,
  isDigit,
  handleKeyDown,
} from '../../../common/Common.js';
import MaterialNameDetail from './MaterialNameDetail';
import { createMaterialIq3CSV, getCSVMaterialIQ3Info, getMaterialIQ3Info, getMaxCode } from '../../../common/CommonAPI';
import { ErrorMessage } from '../../../common/Message';
import { NOT_CHANGE, pageSizes } from '../../../common/Constant.js';
import sort_up from '../../../../assets/images/sort_up.png';
import sort_down from '../../../../assets/images/sort_down.png';
import Draggable from 'react-draggable';

dayjs.extend(customParseFormat);

const plusMinus = [
  {
    label: '+',
    key: '1',
  },
  {
    label: '-',
    key: '2',
  },
];

const RadioGroup = Radio.Group;
const { TextArea } = Input;

const MaterialNameList = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    setSplitPaneSize: setSplitPaneSize,
    showAddNewModal: showAddNewModal,
    showXMLInputModal: showXMLInputModal,
    showGroupEditModal: showGroupEditModal,
    showDeleteModal: showDeleteModal,
    showBulkDeleteModal: showBulkDeleteModal, // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
    showDeleteAllModal: showDeleteAllModal,
    showCSVInputModal: showCSVInputModal,
    getEditMode: editMode,
    discardChange: actionArr,
    setDiscardChangeMode: setDiscardOKAction,
    updateEditMode: setEditMode,
    setEditModeCancelConfirm: setEditModeCancelConfirm,
    discardConfirmOk: discardConfirmOk,
    getCsvExportFileName: csvExportFileName,
    getCsvExportData: getCsvExportData,
    submitCsvImportData: submitCsvImportData,
  }));

  const csvExportFileName = `材料名称＊（名称毎比重、材料粗利係数）_${formatDateString(todayTime())}.csv`;

  const detailRef = useRef();
  const messageRef = useRef([]);
  const navigate = useNavigate();

  const [paramSelected, setParamSelected] = useState('材料名称＊（名称毎比重、材料粗利係数）');
  const [paramType, setParamType] = useState('iq3');
  const [materialNameData, setMaterialNameData] = useState([]);
  const [tempMaterialClass, setTempMaterialClass] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [materialTypeIQ3List, setMaterialTypeIQ3List] = useState([]);

  const [editMode, setEditMode] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [checkedRowKeys, setCheckedRowKeys] = useState([]);
  const [changeRecordKey, setChangeRecordKey] = useState();
  const [dataState, setDataState] = useState();
  const [nameKeyword, setNameKeyWord] = useState('');
  const [modelKeyword, setModelKeyWord] = useState('');
  const [hasCheckData, setHasCheckData] = useState(true);
  const [showFlag, setShowFlag] = useState(1);
  const [filterKey, setFilterKey] = useState();
  const [isFilter, setIsFilter] = useState(true);
  const [chkData, setChkData] = useState(0);
  const [visibleGroupEditModal, setVisibleGroupEditModal] = useState(false);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [visibleCSVInput, setVisibleCSVInput] = useState(false);
  const [visibleCSVOutput, setVisibleCSVOutput] = useState(false);
  const [visibleXMLInput, setVisibleXMLInput] = useState(false);
  const [visibleAddNewModal, setVisibleAddNewModal] = useState(false);
  const [childTitle, setChildTitle] = useState('');

  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [updateConfirm, setUpdateConfirm] = useState(false);
  const [editModeCancelConfirm, setEditModeCancelConfirm] = useState(false);
  const [discardOKAction, setDiscardOKAction] = useState(actionArr[0]);
  const [unitPrice, setUnitPrice] = useState(10);
  const [updateCancelConfirm, setUpdateCancelConfirm] = useState(false);
  const [plusMinusAct, setPlusMinusAct] = useState('+');
  const [isAdd, setIsAdd] = useState(false);
  const [isGpUpd, setIsGpUpd] = useState(false);
  const [tmpFilteredData, setTmpFilteredData] = useState();
  const [zairyoName, setZairyoName] = useState();
  const [materialTypeIq3IdState, setMaterialTypeIq3IdState] = useState();
  const [thickness, setThickness] = useState();

  // Content Resize
  const [sizes, setSizes] = useState(['60%']);

  //　テーブル列Resizable用変数
  // 一覧用変数
  const [detailMaterialNameWidth, setDetailMaterialNameWidth] = useState(150);
  const [materialNameWidth, setMaterialNameWidth] = useState(150);
  const [pricePerWeightWidth, setPricePerWeightWidth] = useState(100);
  const [remarkWidth, setRemarkWidth] = useState(200);
  // 一括編集用変数
  const [detailMaterialNameWidthEdit, setDetailMaterialNameWidthEdit] = useState(150);
  const [materialNameWidthEdit, setMaterialNameWidthEdit] = useState(150);
  const [pricePerWeightWidthEdit, setPricePerWeightWidthEdit] = useState(100);
  const [remarkWidthEdit, setRemarkWidthEdit] = useState(200);
  // 一括編集選択行
  const [chkrowscount, setChkRowsCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemNo, setItemNo] = useState(1);
  const [itemNoTmp, setItemNoTmp] = useState(0);

  const [fromThickness, setFromThickness] = useState('');
  const [toThickness, setToThickness] = useState('');

  const [unitPriceKey, setUnitPriceKey] = useState('');

  const [showEdtConfirmOK, setShowEdtConfirmOK] = useState();
  const [showEdtConfirmCancle, setShowEdtConfirmCancle] = useState();

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  // 一括削除
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [deleteSelectedRowKeys, setDeleteSelectedRowKeys] = useState([]);
  const [isDeleteAll, setIsDeleteAll] = useState(false);

  // pagination
  const [pageSize, setPageSize] = useState(30);
  const [editPageSize, setEditPageSize] = useState(30);
  const [editPage, setEditPage] = useState(1);

  const [totalCount, setTotalCount] = useState(0);
  const [ascSortFlg, setAscSortFlg] = useState('ASC');
  const [sortNm, setSortNm] = useState('id');
  const [filterDatas, setFilterDatas] = useState({
    thickStart: 0,
    thickEnd: 0,
    unitPrice: 0,
    materialTypeIq3Id: 0,
    isUsedFlg: 1,
  });
  const [tblLoading, setTblLoading] = useState(false);
  const [isFilterFlg, setIsFilterFlg] = useState(false);

  const inputItemRef = {};

  const releaseDate = '2023-10-01';

  // 2025-05-20 ブラウザのテキストの拡大率が100％の場合、ページを変える部分(1番下)が、
  // ブラウザを最大化していないと表示されない。90％以下であれば最大化していなくても表示される。
  // 縮小しても表示されるようにしてもらえたらありがたいです。
  const [tableScrollY, setTableScrollY] = useState(500);
  const updateTableHeight = () => {
    const searchHeight = 55;
    const footerHeight = 150;
    const availableHeight = window.innerHeight - searchHeight - footerHeight - 48; // 48 is margin
    setTableScrollY(availableHeight);
  };

  useEffect(() => {
    updateTableHeight();
    window.addEventListener('resize', updateTableHeight);
    return () => window.removeEventListener('resize', updateTableHeight);
  }, []);

  useEffect(() => {
    getMaterialIQ3Data();
  }, []);

  useEffect(() => {
    if (props.showConfirmMsgs !== undefined) {
      setShowEdtConfirmOK(props.showConfirmMsgs?.editOk);
      setShowEdtConfirmCancle(props.showConfirmMsgs?.editCancel);
    } else {
      setShowEdtConfirmOK(true);
      setShowEdtConfirmCancle(true);
    }
  }, [props.showConfirmMsgs]);

  // 板金子部品材料マスタ情報を取得する
  const getMaterialIQ3Data = async () => {
    props?.loading(true); // Waitingダイアログを表示にする
    let materialNameData = [];
    let pageBefore =
      props.initialParam === 'iq3_materialName' && props?.rowSelectPage !== undefined && props?.rowSelectPage !== 0
        ? props?.rowSelectPage - 1
        : 0;
    setCurrentPage(pageBefore === 0 ? 1 : props?.rowSelectPage);
    let propSortFlg =
      props.initialParam === 'iq3_materialName' && props?.ascSortFlg !== undefined ? props?.ascSortFlg : ascSortFlg;
    let propSortNm = props.initialParam === 'iq3_materialName' && props?.sortNm !== undefined ? props?.sortNm : sortNm;
    let propFilterDatas =
      props.initialParam === 'iq3_materialName' && props?.filterDatas !== undefined ? props?.filterDatas : filterDatas;
    let materialNameInfo = await getMaterialIQ3Info(pageSize, pageBefore, propSortFlg, propSortNm, propFilterDatas);
    if (materialNameInfo) {
      materialNameData = materialNameInfo ? materialNameInfo?.data : [];
      setTotalCount(materialNameInfo?.totalCount);
    }
    setMaterialNameData(materialNameData);
    setFilteredData(materialNameData);
    setTempMaterialClass(materialNameData?.[0]);
    setSelectedRowKeys(materialNameData?.[0]?.id);
    setSelectedData(materialNameData?.[0]);
    // 前回選択された行がある場合
    if (props.initialParam === 'iq3_materialName' && props.selectedRowId !== undefined && props.selectedRowId !== 0) {
      let selectedRowData = materialNameData?.filter((item) => item.id === props?.selectedRowId);
      if (selectedRowData?.length > 0) {
        setSelectedRowKeys(selectedRowData?.[0]?.id);
        setSelectedData(selectedRowData?.[0]);
      }
      if (propFilterDatas?.thickStart !== undefined)
        setFromThickness(propFilterDatas?.thickStart === 0 ? '' : propFilterDatas?.thickStart);
      if (propFilterDatas?.thickEnd !== undefined)
        setToThickness(propFilterDatas?.thickEnd === 0 ? '' : propFilterDatas?.thickEnd);
      if (propFilterDatas?.unitPrice !== undefined)
        setUnitPriceKey(propFilterDatas?.unitPrice === 0 ? '' : propFilterDatas?.unitPrice);
      if (propFilterDatas?.materialTypeIq3Id !== undefined)
        setDataState(propFilterDatas?.materialTypeIq3Id === 0 ? '全て' : propFilterDatas?.materialTypeIq3Id);
      if (propFilterDatas?.isUsedFlg !== undefined) setShowFlag(propFilterDatas?.isUsedFlg);
      setFilterDatas(propFilterDatas);
    }
    props.setParam(paramType, paramSelected);
    setShowFlag(1);
    setIsFilter(true);
    let materialTypeIQ3List = await getMaterialTypeIQ3List();
    setMaterialTypeIQ3List(materialTypeIQ3List);
    props?.loading(false); // Waitingダイアログを非表示にする
  };
  const getMaterialIQ3 = async () => {
    let pageBefore = currentPage - 1;
    let materialNameData = [];
    let materialNameInfo = await getMaterialIQ3Info(pageSize, pageBefore, ascSortFlg, sortNm, filterDatas);
    if (materialNameInfo) {
      materialNameData = materialNameInfo ? materialNameInfo?.data : [];
    }
    setMaterialNameData(materialNameData);
    setFilteredData(materialNameData);
    setTempMaterialClass(materialNameData?.[0]);

    props.setParam(paramType, paramSelected);
    setShowFlag(1);
    setIsFilter(true);
    let materialTypeIQ3List = await getMaterialTypeIQ3List();
    setMaterialTypeIQ3List(materialTypeIQ3List);
  };

  const columns = [
    {
      key: 'No',
      title: 'No',
      dataIndex: 'No',
      width: 55,
      render: (id, record, index) => {
        let pageBefore = currentPage - 1;
        let startPage = pageBefore < 0 ? 0 : pageSize * pageBefore;
        return startPage + (index + 1); // IQX_WEBEST-240
      },
      className: 'cm-a-right',
    },
    {
      key: 'code',
      title: 'コード',
      dataIndex: 'code',
      width: 120,
      sorter: (a, b) => setSortNm('code'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'name',
      title: '材料名',
      dataIndex: 'name',
      width: visibleGroupEditModal ? detailMaterialNameWidthEdit : detailMaterialNameWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (visibleGroupEditModal) {
            setDetailMaterialNameWidthEdit(size.width);
          } else {
            setDetailMaterialNameWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('name'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'materialName',
      title: '材質名称',
      dataIndex: 'materialTypeIq3Id',
      width: visibleGroupEditModal ? materialNameWidthEdit : materialNameWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (visibleGroupEditModal) {
            setMaterialNameWidthEdit(size.width);
          } else {
            setMaterialNameWidth(size.width);
          }
        },
      }),
      render: (value) => getMaterilTypeIQ3Name(value),
      sorter: (a, b) => setSortNm('materialTypeIq3Id'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'thick',
      title: '板厚',
      dataIndex: 'info',
      width: 80,
      className: 'cm-a-right',
      render: (info) => info.thick,
      sorter: (a, b) => setSortNm('thick'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'gravity',
      title: '比重',
      dataIndex: 'info',
      width: 80,
      className: 'cm-a-right',
      render: (info) => info.gravity,
      sorter: (a, b) => setSortNm('gravity'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'unitPrice',
      title: '重量単価',
      dataIndex: 'info',
      className: 'cm-a-right',
      render: (text, record) => {
        return JPYs.format(record.info.unitPrice);
      },
      width: visibleGroupEditModal ? pricePerWeightWidthEdit : pricePerWeightWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (visibleGroupEditModal) {
            setPricePerWeightWidthEdit(size.width);
          } else {
            setPricePerWeightWidth(size.width);
          }
        },
      }),
      sorter: (a, b) => setSortNm('unitPrice'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'created',
      title: '作成日',
      dataIndex: 'created',
      width: 100,
      render: (created) => formatDate(created),
      sorter: (a, b) => setSortNm('created'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'modified',
      title: '更新日',
      dataIndex: 'modified',
      width: 100,
      render: (modified) => formatDate(modified),
      sorter: (a, b) => setSortNm('modified'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'modifier',
      title: '更新者',
      dataIndex: 'modifier',
      width: 150,
      sorter: (a, b) => setSortNm('modifier'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'remarks',
      title: '備考',
      dataIndex: 'info',
      width: visibleGroupEditModal ? remarkWidthEdit : remarkWidth,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: (e, { size }) => {
          if (visibleGroupEditModal) {
            setRemarkWidthEdit(size.width);
          } else {
            setRemarkWidth(size.width);
          }
        },
      }),
      render: (info) => info.remarks,
      sorter: (a, b) => setSortNm('remarks'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
    {
      key: 'isUsed',
      title: '表示',
      dataIndex: 'info',
      width: 95,
      render: (text, record) => {
        return record.info.isUsed && <Image preview={false} width={13} src={checked} style={{ marginLeft: '3px' }} />;
      },
      className: 'cm-a-center',
      sorter: (a, b) => setSortNm('isUsed'),
      sortIcon: ({ sortOrder }) => (
        <>
          <Image
            preview={false}
            src={sort_up}
            style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
          />
          <Image
            preview={false}
            src={sort_down}
            style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
          />
        </>
      ),
    },
  ];

  // テーブル幅Resizable
  const components = {
    header: {
      cell: ResizableTitle,
    },
  };

  const tableColumns = columns?.map((item) => ({
    ...item,
  }));

  // 板金子部品材質名をIDで取得する
  const getMaterilTypeIQ3Name = (id) => {
    return materialTypeIQ3List?.filter((item) => item.value === id)?.[0]?.label;
  };

  // 入力ボックスは金額タイプの場合、他の項目CSSを参照にして利用
  const getAntInputBoxClassName = (id, mode = true) => {
    let classList = document.getElementById(id)?.classList;
    let className = '';
    if (classList?.length > 0)
      className =
        ' ' +
        Object.values(classList)?.filter(
          (v) => v !== 'ant-input' && v !== 'input-editable' && v !== 'input-non-editable'
        );
    if (mode) {
      return 'ant-input input-editable' + className;
    } else {
      return 'input-non-editable';
    }
  };
  // 材料名称検索
  const filterOption = (input, option) => option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;

  // 新規作成の項目値を変更した場合、
  const onChangeInputForm = (name, value, isCheckZenkaku = true) => {
    if (isCheckZenkaku && regexExp.test(value)) {
      // 全角の場合、
      value = toHalfWidth(value); // 半角へ変換
    }
    // 2025-07-14 IQX_WEBEST-438 数値以外が入力できてしまう
    // ② 数値バリデーション（小数OK）
    const isValid = /^[0-9]*\.?[0-9]*$/.test(value);

    if (!isValid) {
      return;
    }
    if (name === 'thick') {
      setTempMaterialClass((prevData) => ({
        ...prevData,
        info: { ...prevData?.info, thick: value },
      }));
      setThickness(value);
    } else {
      setTempMaterialClass((prevData) => ({
        ...prevData,
        info: { ...prevData.info, gravity: value },
      }));
    }
  };

  const addModalContent = (
    <div id="addNewMaterialName" style={{ marginTop: 8 }}>
      <RTable id="param_detail_tbl" className="propertiesTbl">
        <thead>
          {/* <tr>
            <td className="param-detail-tbl-val-title">No</td>
            <td style={{ verticalAlign: 'middle', height: 28, padding: 3 }}>
              <label> {tempMaterialClass.key + 1} </label>
            </td>
          </tr> */}
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">コード</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <Input
                type="text"
                data-name="code"
                className={'input-editable'}
                value={tempMaterialClass?.code}
                id="code"
                name="code"
                onChange={(e) => {
                  setTempMaterialClass({ ...tempMaterialClass, code: e.target.value });
                }}
                ref={(ref) => {
                  inputItemRef['code'] = ref;
                }}
                maxLength={50}
              />
            </td>
          </tr>

          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">材質名称</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <Select
                showSearch
                className={'search-select'}
                style={{ width: '98.2%' }}
                onChange={(e) => {
                  /* const data = { ...tempMaterialClass };
                  //data['materialTypeIq3Id'] = e;
                  if (tempMaterialClass.info.thick !== '' && zairyoName === '') {
                    // data['detailMaterialName'] = e + '_' + data.info.thick;
                    setZairyoName(e + '_' + data.info.thick);
                  } */
                  setTempMaterialClass((prevData) => ({
                    ...prevData,
                    materialTypeIq3Id: e,
                    /* info: {
                      ...prevData.info,
                      gravity: materialTypeIQ3List?.filter((item) => item.value === e)?.[0]?.gravity,
                    }, */
                  }));
                  setMaterialTypeIq3IdState(e);
                }}
                filterOption={filterOption}
                id="materialTypeIq3Id"
                name="materialTypeIq3Id"
                defaultValue=""
              >
                <Select.Option id="defaultValue" value="">
                  {defaultValue.materialTypeIq3}
                </Select.Option>
                {materialTypeIQ3List?.map((item, index) => (
                  <Select.Option key={index} id={'materialClassName' + item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </td>
          </tr>
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">板厚</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <Input
                id="thick"
                name="thick"
                type="text"
                data-name="name"
                className={'input-editable'}
                value={tempMaterialClass?.info?.thick}
                onBlur={(e) => onChangeInputForm(e.target.name, e.target.value)}
                onPressEnter={(e) => onChangeInputForm(e.target.name, e.target.value)}
                // 2025-07-01 IQX_WEBEST-438 数値以外が入力できてしまう
                // onKeyDown={(e) => handleKeyDown(e, true)}
                onChange={(e) => onChangeInputForm(e.target.name, e.target.value, false)}
                ref={(ref) => {
                  inputItemRef['thick'] = ref;
                }}
                maxLength={Number.MAX_SAFE_INTEGER}
              />
            </td>
          </tr>
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">材料名</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <Input
                type="text"
                data-name="name"
                className={'input-editable'}
                value={tempMaterialClass?.name === '' ? zairyoName : tempMaterialClass?.name}
                id="name"
                name="name"
                onChange={(e) => {
                  setZairyoName(e.target.value);
                  setTempMaterialClass({
                    ...tempMaterialClass,
                    name: e.target.value,
                  });
                }}
                ref={(ref) => {
                  inputItemRef['name'] = ref;
                }}
                maxLength={50}
              />
            </td>
          </tr>
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">比重</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <Input
                id="gravity"
                name="gravity"
                type="text"
                data-name="name"
                className={'input-editable'}
                value={tempMaterialClass?.info?.gravity}
                onBlur={(e) => onChangeInputForm(e.target.name, e.target.value)}
                onPressEnter={(e) => onChangeInputForm(e.target.name, e.target.value)}
                // 2025-07-01 IQX_WEBEST-438 数値以外が入力できてしまう
                // onKeyDown={(e) => handleKeyDown(e, true)}
                onChange={(e) => onChangeInputForm(e.target.name, e.target.value, false)}
                ref={(ref) => {
                  inputItemRef['gravity'] = ref;
                }}
                maxLength={Number.MAX_SAFE_INTEGER}
              />
            </td>
          </tr>
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">重量単価</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <CurrencyInput
                id="unitPrice"
                name="unitPrice"
                type="text"
                data-name="name"
                className={getAntInputBoxClassName('unitPrice') + ' param-currency'}
                value={tempMaterialClass?.info?.unitPrice}
                defaultValue={0}
                onValueChange={(e) => {
                  setTempMaterialClass((prevData) => ({
                    ...prevData,
                    info: { ...prevData.info, unitPrice: e },
                  }));
                }}
                prefix="¥"
                decimalsLimit={100}
                ref={(ref) => {
                  inputItemRef['unitPrice'] = ref;
                }}
                maxLength={Number.MAX_SAFE_INTEGER}
              />
            </td>
          </tr>
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">作成日</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <label className="param_detail-title-label">
                {tempMaterialClass?.created ? formatDate(tempMaterialClass?.created) : ''}
              </label>
            </td>
          </tr>
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">更新日</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <label className="param_detail-title-label">
                {tempMaterialClass?.modified ? formatDate(tempMaterialClass?.modified) : ''}
              </label>
            </td>
          </tr>
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">備考</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <TextArea
                type="text"
                data-name="name"
                className={'input-editable'}
                style={{ margin: 5, padding: 5, width: '98.3%' }}
                value={tempMaterialClass?.info?.remarks}
                onChange={(e) => {
                  setTempMaterialClass((prevData) => ({
                    ...prevData,
                    info: { ...prevData.info, remarks: e.target.value },
                  }));
                }}
                maxLength={2048}
              />
            </td>
          </tr>
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">表示</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <RadioGroup
                name="isUsed"
                defaultValue={true}
                className="radioCustomerGpEdit"
                onChange={(e) => {
                  setTempMaterialClass((prevData) => ({
                    ...prevData,
                    info: { ...prevData.info, isUsed: e.target.value },
                  }));
                }}
                value={tempMaterialClass?.info?.isUsed}
              >
                <Radio value={true}>オン</Radio>
                <Radio value={false}>オフ</Radio>
              </RadioGroup>
            </td>
          </tr>
        </thead>
      </RTable>
    </div>
  );

  const onSelectedRowKeysChange = (checked, record, index) => {
    let selectedRowKeys = [...checked];
    setCheckedRowKeys(selectedRowKeys);
    setChkRowsCount(selectedRowKeys?.length);
  };

  const rowSelection = {
    onChange: onSelectedRowKeysChange,
  };

  const groupEditOK = (e) => {
    setIsAdd(true);
    setUpdateCancelConfirm(true);
  };

  const groupEditCancel = (e) => {
    setIsAdd(false);
    setUpdateCancelConfirm(true);
  };

  const handlePageSizeChangeEdit = (current, pagesize) => {
    setEditPageSize(pagesize);
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setTblLoading(true); // Waitingダイアログを表示にする
    let pageBefore = pagination?.current - 1;
    let ascSortFlg = 'ASC';
    if (sorter?.order === undefined) {
      ascSortFlg = '';
    } else if (sorter?.order === 'ascend') {
      ascSortFlg = 'ASC';
    } else if (sorter?.order === 'descend') {
      ascSortFlg = 'DESC';
    }
    setAscSortFlg(ascSortFlg);
    let materialIQ3Info = await getMaterialIQ3Info(
      pagination?.pageSize,
      pageBefore,
      ascSortFlg,
      sorter?.columnKey,
      filterDatas
    );
    if (materialIQ3Info) {
      let materialIQ3 = materialIQ3Info ? materialIQ3Info?.data : [];
      setFilteredData(materialIQ3);
    }
    setTblLoading(false); // Waitingダイアログを表示にする
  };

  const gpEditModalContent = (
    <Form>
      <Row>
        <Col span="13">
          <p style={{ fontSize: '13.5px', marginBottom: 6, marginTop: 0, fontWeight: '700' }}>
            {chkrowscount}件を選択中
          </p>
          <Table
            showSorterTooltip={false}
            components={components}
            dataSource={filteredData}
            columns={tableColumns}
            scroll={{ y: 480, x: '50vw' }}
            pagination={{
              position: ['bottomLeft'],
              total: totalCount,
              showTotal: (total, range) => `全${total}件中${range[0]}件〜${range[1]}件を表示`,
              defaultCurrent: 1,
              pageSize: editPageSize,
              pageSizeOptions: pageSizes,
              current: editPage,
              showSizeChanger: true,
              onShowSizeChange: handlePageSizeChangeEdit,
              onChange: (page) => {
                setEditPage(page);
              },
            }}
            className="groupEditTable"
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            onChange={handleTableChange}
            loading={tblLoading}
          />
        </Col>
        <Col span="11">
          <div
            style={{
              height: 749,
              marginTop: 28,
              fontSize: '13.5px',
              overflowY: 'auto',
              whiteSpace: 'nowrap',
            }}
          >
            <RTable id="param_detail_tbl" className="propertiesTbl">
              <thead>
                {/* コード */}
                <tr className="detail-tbl-row">
                  <td className="param-detail-tbl-val-title">
                    <label className="param_detail-title-label">コード</label>
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <Input
                      placeholder={visibleGroupEditModal ? NOT_CHANGE : ''}
                      className={'input-editable'}
                      name="code"
                      id="code"
                      value={tempMaterialClass?.code}
                      type="text"
                      ref={(ref) => {
                        inputItemRef['code'] = ref;
                      }}
                      maxLength={50}
                      onChange={(e) => {
                        setTempMaterialClass({ ...tempMaterialClass, code: e.target.value });
                      }}
                    />
                  </td>
                </tr>
                {/* 材料名 */}
                <tr className="detail-tbl-row">
                  <td className="param-detail-tbl-val-title">
                    <label className="param_detail-title-label">材料名</label>
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <Input
                      placeholder={visibleGroupEditModal ? NOT_CHANGE : ''}
                      className={'input-editable'}
                      name="name"
                      id="name"
                      value={tempMaterialClass?.name}
                      type="text"
                      ref={(ref) => {
                        inputItemRef['name'] = ref;
                      }}
                      maxLength={50}
                      onChange={(e) => {
                        setTempMaterialClass({ ...tempMaterialClass, name: e.target.value });
                      }}
                    />
                  </td>
                </tr>
                {/* 材質名称 */}
                <tr className="detail-tbl-row">
                  <td className="param-detail-tbl-val-title">
                    <label className="param_detail-title-label">材質名称</label>
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <Select
                      className={'search-select'}
                      style={{ width: '50%' }}
                      onChange={(e) => {
                        setTempMaterialClass({ ...tempMaterialClass, materialTypeIq3Id: e });
                      }}
                      id="materialTypeIq3Id"
                      name="materialTypeIq3Id"
                      defaultValue={visibleGroupEditModal ? NOT_CHANGE : defaultValue.materialTypeIq3}
                    >
                      <Select.Option id="defaultValue" value={defaultValue.materialTypeIq3}>
                        {defaultValue.materialTypeIq3}
                      </Select.Option>
                      {materialTypeIQ3List?.map((item, index) => (
                        <Select.Option key={index} id={'materialRef' + item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </td>
                </tr>
                {/* 板厚 */}
                <tr className="detail-tbl-row">
                  <td className="param-detail-tbl-val-title">
                    <label className="param_detail-title-label">板厚</label>
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <Input
                      placeholder={visibleGroupEditModal ? NOT_CHANGE : ''}
                      id="thick"
                      name="thick"
                      type="text"
                      data-name="thick"
                      className={'input-editable'}
                      value={tempMaterialClass?.info?.thick}
                      onChange={(e) => {
                        setTempMaterialClass((prevData) => ({
                          ...prevData,
                          info: { ...prevData.info, thick: e.target.value },
                        }));
                      }}
                      ref={(ref) => {
                        inputItemRef['thick'] = ref;
                      }}
                      maxLength={Number.MAX_SAFE_INTEGER}
                    />
                  </td>
                </tr>
                {/* 比重 */}
                <tr className="detail-tbl-row">
                  <td className="param-detail-tbl-val-title">
                    <label className="param_detail-title-label">比重</label>
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <Input
                      placeholder={visibleGroupEditModal ? NOT_CHANGE : ''}
                      className={'input-editable'}
                      name="gravity"
                      id="gravity"
                      value={tempMaterialClass?.info?.gravity}
                      type="text"
                      onBlur={(e) => onChangeInputForm(e.target.name, e.target.value)}
                      onPressEnter={(e) => onChangeInputForm(e.target.name, e.target.value)}
                      onChange={(e) => onChangeInputForm(e.target.name, e.target.value, false)}
                      ref={(ref) => {
                        inputItemRef['gravity'] = ref;
                      }}
                      maxLength={Number.MAX_SAFE_INTEGER}
                    />
                  </td>
                </tr>
                {/* 重量単価 */}
                <tr className="detail-tbl-row">
                  <td className="param-detail-tbl-val-title">
                    <label className="param_detail-title-label">重量単価</label>
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <CurrencyInput
                      placeholder={visibleGroupEditModal ? NOT_CHANGE : ''}
                      type="text"
                      id="unitPrice"
                      data-name="name"
                      className={getAntInputBoxClassName('unitPrice') + ' param-currency'}
                      value={tempMaterialClass?.info?.unitPrice}
                      onValueChange={(e) => {
                        setTempMaterialClass((prevData) => ({
                          ...prevData,
                          info: { ...prevData.info, unitPrice: e },
                        }));
                      }}
                      prefix="¥"
                      decimalsLimit={100}
                      ref={(ref) => {
                        inputItemRef['unitPrice'] = ref;
                      }}
                      maxLength={Number.MAX_SAFE_INTEGER}
                    />
                  </td>
                </tr>
                {/* 備考 */}
                <tr className="detail-tbl-row">
                  <td className="param-detail-tbl-val-title">
                    <label className="param_detail-title-label">備考</label>
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <TextArea
                      placeholder={visibleGroupEditModal ? NOT_CHANGE : ''}
                      type="text"
                      data-name="name"
                      className={'input-editable'}
                      style={{ margin: 5, padding: 5, width: '98.3%' }}
                      value={tempMaterialClass?.info?.remarks}
                      onChange={(e) => {
                        setTempMaterialClass((prevData) => ({
                          ...prevData,
                          info: { ...prevData.info, remarks: e.target.value },
                        }));
                      }}
                      maxLength={2048}
                    />
                  </td>
                </tr>
                {/* 表示 */}
                <tr className="detail-tbl-row">
                  <td className="param-detail-tbl-val-title">
                    <label className="param_detail-title-label">表示</label>
                  </td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <RadioGroup
                      name="isUsed"
                      defaultValue={0}
                      className="radioCustomerGpEdit"
                      onChange={(e) => {
                        setTempMaterialClass((prevData) => ({
                          ...prevData,
                          info: { ...prevData.info, isUsed: e.target.value },
                        }));
                      }}
                      value={tempMaterialClass?.info?.isUsed}
                    >
                      <Radio value={0}>{NOT_CHANGE}</Radio>
                      <Radio value={1}>オン</Radio>
                      <Radio value={2}>オフ</Radio>
                    </RadioGroup>
                  </td>
                </tr>
              </thead>
            </RTable>
          </div>
        </Col>
      </Row>
      <Row
        justify="end"
        style={{
          marginBottom: 0,
          marginTop: -40,
        }}
      >
        <Button style={{ marginRight: 5 }} className="mainButton" onClick={groupEditOK}>
          更新
        </Button>
        <Button className="cancelButton" onClick={groupEditCancel}>
          {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
          {/* 破棄 */}
          戻る
        </Button>
      </Row>
    </Form>
  );

  const onRowSelect = (record, index) => {
    setChangeRecordKey(record.id);
    //setItemNo((currentPage - 1) * 25 + (index + 1));
    if (editMode) {
      setDiscardOKAction(actionArr[0]);
      setItemNoTmp((currentPage - 1) * 25 + (index + 1));
      let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
      setEditModeCancelConfirm(moveInEdit);
      if (!moveInEdit) {
        setEditMode(false);
        document.getElementById('update').style.display = 'none';
        document.getElementById('discard').style.display = 'none';
        document.getElementById('edit').style.display = 'block';
        setSelectedRowKeys(record.id);
        setSelectedData(record);
        setItemNo((currentPage - 1) * 25 + (index + 1));
        navigate(':iq3.materialName');
      }
    } else {
      setSelectedRowKeys(record.id);
      setSelectedData(record);
      setItemNo((currentPage - 1) * 25 + (index + 1));
      navigate(':iq3.materialName');
    }
    props?.updateSelectedRowId(record?.id, 0, currentPage, ascSortFlg, sortNm, filterDatas);
    props?.resetInitialParam();
  };

  const handleOk = (e) => {
    setUpdateConfirm(false);
    setVisibleGroupEditModal(false);
    setVisibleDeleteModal(false);
    setVisibleCSVOutput(false);
    setVisibleAddNewModal(false);
  };

  const handleCancel = (e) => {
    setCancelConfirm(false);
    setVisibleGroupEditModal(false);
    setVisibleDeleteModal(false);
    setVisibleCSVOutput(false);
    setVisibleAddNewModal(false);
    setVisibleCSVInput(false);
    setVisibleXMLInput(false);
    setUpdateCancelConfirm(false);
  };

  const gpEditCheck = (newObj, oldObj, objKey) => {
    if (newObj[objKey] === '') {
      return oldObj[objKey];
    } else if (newObj.info[objKey] === '') {
      return oldObj.info[objKey];
    } else {
      setIsGpUpd(newObj[objKey] === oldObj[objKey] || newObj.info[objKey] === oldObj.info[objKey]);
      return Object.keys(newObj?.info)?.filter((v) => v === objKey)?.length > 0 ? newObj.info[objKey] : newObj[objKey];
    }
  };

  const updConfirmOk = async (e) => {
    let stateData = [];
    stateData = JSON.parse(JSON.stringify(filteredData));
    setUpdateCancelConfirm(false);
    if (visibleAddNewModal) {
      // 画面の入力チェック
      if (!(await detailRef.current.formValidation(inputItemRef, formValidatorMode.Create, false))) {
        return;
      }
      props?.loading(true); // Waitingダイアログを表示にする
      let createdData = await createMaterialIq3Data(tempMaterialClass);
      stateData.push(createdData);
      setTmpFilteredData(stateData);
      setMaterialNameData(stateData);
      resetAddModal();
      //onRowSelect(tempMaterialClass);
      setSelectedRowKeys(createdData?.id);
      setSelectedData(createdData);
      setItemNo(createdData?.id);
      // setCurrentPage(1);
      props?.updateSelectedRowId(createdData?.id, 0, 1, ascSortFlg, sortNm, filterDatas);
      setVisibleAddNewModal(false);
      // getMaterialIQ3Data();
      setIsFilterFlg(true);
      props?.loading(false); // Waitingダイアログを非表示にする
    } else if (visibleGroupEditModal) {
      // 画面の入力チェック
      if (!(await detailRef.current.formValidation(inputItemRef, formValidatorMode.BulkEdit, false))) {
        return;
      }
      props?.loading(true); // Waitingダイアログを表示にする
      if (checkedRowKeys?.length > 0) {
        let selectedRowData = [];
        const updatedData = stateData?.map((obj) => {
          if (checkedRowKeys?.includes(obj?.id)) {
            let isUsedEdit = obj?.info?.isUsed;
            if (tempMaterialClass?.info?.isUsed > 0) {
              isUsedEdit = tempMaterialClass?.info?.isUsed === 1 ? true : false;
            }
            let checkedData = {
              ...obj,
              code:
                tempMaterialClass?.code === undefined || tempMaterialClass?.code === ''
                  ? obj.code
                  : tempMaterialClass?.code,
              name:
                tempMaterialClass?.name === undefined || tempMaterialClass?.name === ''
                  ? obj.name
                  : tempMaterialClass?.name,
              materialTypeIq3Id:
                tempMaterialClass?.materialTypeIq3Id === defaultValue.materialTypeIq3 ||
                tempMaterialClass?.materialTypeIq3Id === NOT_CHANGE
                  ? obj.materialTypeIq3Id
                  : tempMaterialClass?.materialTypeIq3Id,
              info: {
                ...obj.info,
                isUsed: isUsedEdit,
                thick:
                  tempMaterialClass?.info?.thick === undefined || tempMaterialClass?.info?.thick === ''
                    ? obj?.info?.thick
                    : tempMaterialClass?.info?.thick,
                gravity:
                  tempMaterialClass?.info?.gravity === undefined || tempMaterialClass?.info?.gravity === ''
                    ? obj?.info?.gravity
                    : tempMaterialClass?.info?.gravity,
                unitPrice:
                  tempMaterialClass?.info?.unitPrice === undefined || tempMaterialClass?.info?.unitPrice === ''
                    ? obj?.info?.unitPrice
                    : tempMaterialClass?.info?.unitPrice,
                remarks:
                  tempMaterialClass?.info?.remarks === undefined || tempMaterialClass?.info?.remarks === ''
                    ? obj?.info?.remarks
                    : tempMaterialClass?.info?.remarks,
              },
              modified: isGpUpd ? obj.modified : dayjs().format('YYYY-MM-DD'),
            };
            selectedRowData.push(checkedData);
            return checkedData;
          }
          return obj;
        });
        for (var i = 0; i < selectedRowData?.length; i++) {
          await updateMaterialIq3Data(selectedRowData[i]);
        }
        setTmpFilteredData(updatedData);
        setMaterialNameData(updatedData);
      }
      setIsFilterFlg(true);
      props?.loading(false); // Waitingダイアログを非表示にする
      setVisibleGroupEditModal(false);
    }
    setIsFilter(true);
  };

  // 板金子部品材料マスタ情報をDBに新規登録する
  async function createMaterialIq3Data(createData) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'MaterialIq3';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          code: createData.code,
          name: createData.name,
          materialTypeIq3Id: createData.materialTypeIq3Id,
          info: createData.info,
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  const callMethod = (methodName, param) => {
    const method = eval(methodName);
    if (typeof method === 'function') {
      method(param);
    }
  };

  const handleGpEdit = () => {
    setTempMaterialClass({
      code: '',
      name: '',
      materialTypeIq3Id: defaultValue.materialTypeIq3,
      priceHistories: [{ unitPrice: 0, modified: releaseDate }],
      info: { isUsed: 0, thick: '', gravity: '', unitPrice: '', remarks: '' },
      created: releaseDate,
      modified: releaseDate,
    });
    setVisibleGroupEditModal(true);
    setChkRowsCount(0);
    setCheckedRowKeys([]);
  };

  // 編集中破壊確認ポップアップのOKボタン押下
  const discardConfirmOk = () => {
    setEditModeCancelConfirm(false);
    detailRef.current.discardConfirmOk();
  };

  // 編集中破壊確認ポップアップのCancelボタン押下
  const discardConfirmCancel = () => {
    setEditModeCancelConfirm(false);
    detailRef.current.discardConfirmCancel();
    /* setEditModeCancelConfirm(showEdtConfirmCancle);
    if (!showEdtConfirmCancle) {
      detailRef.current.discardConfirmCancel();
    } */
  };

  const updCancelOK = () => {
    setUpdateCancelConfirm(false);
    setVisibleAddNewModal(false);
    setVisibleGroupEditModal(false);
  };

  const updCancelCancel = () => {
    setUpdateCancelConfirm(false);
    if (visibleAddNewModal) {
      setVisibleAddNewModal(true);
    } else if (visibleGroupEditModal) {
      setVisibleGroupEditModal(true);
    }
  };

  const updConfirmCancel = () => {
    setUpdateCancelConfirm(false);
  };

  const handleOkXMLInput = (e) => {
    setVisibleXMLInput(false);
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xml';
    input.onchange = (_) => {
      let files = Array.from(input.files);
    };
    input.click();
  };

  const showGroupEditModal = () => {
    if (editMode) {
      setDiscardOKAction(actionArr[2]);
      updateEditMode(false);
      setEditModeCancelConfirm(true);
    } else {
      handleGpEdit();
    }
    /* setVisibleGroupEditModal(true); */
  };

  // 2025-10-08 IQX_WEBEST-486 複数削除ができてほしい
  // 一括削除のため、選択する
  const deleteRowSelection = {
    selectedRowKeys: deleteSelectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setDeleteSelectedRowKeys(newSelectedRowKeys);
    },
  };

  // 一括削除のため、全て選択する
  const handleSelectAll = () => {
    const allIds = filteredData.map((item) => item?.id);
    setDeleteSelectedRowKeys(allIds);
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const bulkDeleteCancel = (e) => {
    setIsBulkDelete(false);
    setDeleteSelectedRowKeys([]);
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const showBulkDeleteModal = () => {
    if (editMode) {
      let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
      setEditModeCancelConfirm(moveInEdit);
      if (!moveInEdit) {
        setEditMode(false);
        document.getElementById('update').style.display = 'none';
        document.getElementById('discard').style.display = 'none';
        document.getElementById('edit').style.display = 'block';
      }
      setIsBulkDelete(true);
    } else {
      setIsBulkDelete(true);
    }
  };

  const showDeleteModal = () => {
    if (editMode) {
      let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
      setEditModeCancelConfirm(moveInEdit);
      if (!moveInEdit) {
        setEditMode(false);
        document.getElementById('update').style.display = 'none';
        document.getElementById('discard').style.display = 'none';
        document.getElementById('edit').style.display = 'block';
      }
      setVisibleDeleteModal(true);
    } else {
      setVisibleDeleteModal(true);
    }
  };

  const showDeleteAllModal = () => {
    if (editMode) {
      let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
      setEditModeCancelConfirm(moveInEdit);
      if (!moveInEdit) {
        setEditMode(false);
        document.getElementById('update').style.display = 'none';
        document.getElementById('discard').style.display = 'none';
        document.getElementById('edit').style.display = 'block';
      }
      setIsDeleteAll(true);
    } else {
      setIsDeleteAll(true);
    }
  };

  const deleteAllCancel = () => {
    setIsDeleteAll(false);
  };

  const deleteAllRecord = async () => {
    setIsDeleteAll(false);
    props?.loading(true); // Waitingダイアログを表示にする
    let deletedData = await deleteAllMaterialIq3Data();
    // IQX_WEBEST-281 使用しているパラメータなのに削除出来てしまう
    if (deletedData) {
      // setFilteredData([]);
      getMaterialIQ3Data();
    }
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  const deleteOK = async () => {
    setVisibleDeleteModal(false);
    props?.loading(true); // Waitingダイアログを表示にする
    let deletedData = await deleteMaterialIq3Data(selectedData.id);
    // IQX_WEBEST-281 使用しているパラメータなのに削除出来てしまう
    if (deletedData !== undefined && deletedData?.id > 0) {
      let data = [...filteredData];
      data = data?.filter((item) => item.id != deletedData?.id);

      setMaterialNameData(data);
      setTmpFilteredData(data);
      setFilteredData(data);
      setSelectedRowKeys(data?.length > 0 ? data[0].id : -1);
      setSelectedData(data?.length > 0 ? data[0] : []);
      props?.updateSelectedRowId(data?.length > 0 ? data[0].id : 0, 0, currentPage, ascSortFlg, sortNm, filterDatas);
      setIsFilter(true);
      getMaterialIQ3Data();
      let deleteAfterTotalCnt = totalCount < 1 ? 0 : totalCount - 1;
      setTotalCount(deleteAfterTotalCnt);
    }
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const bulkDeleteOk = async () => {
    if (!deleteSelectedRowKeys || deleteSelectedRowKeys.length === 0) {
      props?.loading(false);
      error('削除する項目を選択してください。');
      return;
    }
    setVisibleDeleteModal(false);
    props?.loading(true);

    let deletedData = await deleteMaterialIq3BulkData(deleteSelectedRowKeys);

    if (deletedData && deletedData.length > 0) {
      let updatedData = filteredData.filter((item) => !deletedData.includes(item.id));

      setMaterialNameData(updatedData);
      setTmpFilteredData(updatedData);
      setFilteredData(updatedData);

      setSelectedRowKeys(updatedData.length > 0 ? [updatedData[0].id] : []);
      setSelectedData(updatedData.length > 0 ? updatedData[0] : null);
      props?.updateSelectedRowId(
        updatedData.length > 0 ? updatedData[0].id : 0,
        0,
        currentPage,
        ascSortFlg,
        sortNm,
        filterDatas
      );

      setIsFilter(true);
      getMaterialIQ3Data();
      setTotalCount(updatedData.length);

      complete(`${deletedData.length} 件を削除しました。`);
    }

    props?.loading(false);
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  async function deleteMaterialIq3BulkData(ids) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'MaterialIq3/bulk-delete';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify(ids),
      };

      await fetch(Url, otherParam)
        .then(async (response) => await response.json())
        .then((data) => {
          if (data && data?.updateToken) updateAccessToken(data?.updateToken);
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data.map((d) => d.id);
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
          }
        })
        .catch((e) => authorizeError(ErrorMessage().E010));
    } catch (e) {
      error(e.message);
    }
    return ret;
  }

  async function deleteAllMaterialIq3Data() {
    let ret = false;
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'MaterialIq3/delete-all';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = true;
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 板金子部品材料マスタ情報をDBに削除する
  async function deleteMaterialIq3Data(id) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'MaterialIq3/' + id;
      const otherParam = {
        method: 'DELETE',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  const deleteCancel = () => {
    setVisibleDeleteModal(false);
  };

  const showCSVInputModal = () => {
    setVisibleCSVInput(false);
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv';
    input.onchange = (_) => {
      let files = Array.from(input.files);
    };
    input.click();
  };

  const showXMLInputModal = () => {
    setVisibleXMLInput(true);
  };

  const showAddNewModal = () => {
    if (editMode) {
      setDiscardOKAction(actionArr[3]);
      updateEditMode(false);
      let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
      setEditModeCancelConfirm(moveInEdit);
      if (!moveInEdit) {
        setEditMode(false);
        document.getElementById('update').style.display = 'none';
        document.getElementById('discard').style.display = 'none';
        document.getElementById('edit').style.display = 'block';
        // handleAddFormSubmit();
      }
      handleAddFormSubmit();
    } else {
      handleAddFormSubmit();
    }
  };

  const handleAddFormSubmit = async () => {
    const maxCode = await getMaxCode('GetMaterialIq3MaxCode', 'MaterialIq3');
    const nextCode = `DEN-${(maxCode + 1).toString().padStart(4, '0')}`;
    setTempMaterialClass({
      code: nextCode ? nextCode : '',
      name: '',
      materialTypeIq3Id: '',
      priceHistories: [
        {
          unitPrice: 0,
          modified: dayjs().format('YYYY-MM-DD'),
        },
      ],
      info: { isUsed: true, thick: '', gravity: '', unitPrice: 0, remarks: '' },
      created: dayjs().format('YYYY-MM-DD'),
      modified: dayjs().format('YYYY-MM-DD'),
    });
    setZairyoName('');
    setVisibleAddNewModal(true);
    setChildTitle('材料名称');
  };

  const addOK = () => {
    setIsAdd(true);
    setUpdateCancelConfirm(true);
  };

  const addCancel = () => {
    setIsAdd(false);
    // setUpdateCancelConfirm(true);
    setUpdateCancelConfirm(showEdtConfirmCancle);
    if (!showEdtConfirmCancle) {
      updCancelOK();
    }
    /* setVisibleAddNewModal(false); */
  };

  const resetAddModal = () => {
    setTempMaterialClass({
      code: '',
      name: '',
      materialTypeIq3Id: '',
      priceHistories: [
        {
          unitPrice: 0,
          modified: dayjs().format('YYYY-MM-DD'),
        },
      ],
      info: { isUsed: true, thick: '', gravity: '', unitPrice: 0, remarks: '' },
      created: dayjs().format('YYYY-MM-DD'),
      modified: dayjs().format('YYYY-MM-DD'),
    });
    setZairyoName('');
  };

  // フラグ、キーワードに変更された場合、
  useEffect(() => {
    if (isFilterFlg) {
      // 絞り込み、
      getDataByFilter();
    }
  }, [fromThickness, toThickness, unitPriceKey, dataState, showFlag, tmpFilteredData, materialNameData]);

  useEffect(() => {
    if (
      tempMaterialClass !== undefined &&
      tempMaterialClass?.materialTypeIq3Id !== '' &&
      tempMaterialClass?.info?.thick !== ''
    )
      var typeName = materialTypeIQ3List?.find((item) => item.value === tempMaterialClass?.materialTypeIq3Id)?.label;
    if (typeName !== undefined && tempMaterialClass?.info?.thick !== undefined) {
      var zairyo = typeName + '_' + tempMaterialClass?.info?.thick;
      setZairyoName(zairyo);
      setTempMaterialClass({
        ...tempMaterialClass,
        name: zairyo,
      });
    } else setZairyoName('');
  }, [materialTypeIq3IdState, thickness]);

  // 編集中破棄確認ポップアップに「OK」又は「キャンセル」を押下
  useEffect(() => {
    if (!editMode && !editModeCancelConfirm) {
      if (discardOKAction.key === 0 && changeRecordKey !== undefined) {
        setSelectedRowKeys(changeRecordKey);
        setSelectedData(filteredData?.find((item) => item.id === changeRecordKey));
        setItemNo(itemNoTmp);
      } else if (discardOKAction.key === 0 && changeRecordKey === undefined) {
        return;
      } else if (discardOKAction.key === actionArr[6]?.key) {
        // CSV入力
        onClickCSVImport();
      } else if (discardOKAction.key === actionArr[7]?.key) {
        // CSV出力
        onClickCSVExport();
      } else {
        const action = actionArr?.find((item) => item.key === discardOKAction.key);
        if ([1, 4, 5]?.includes(discardOKAction.key)) {
          callMethod(action.methodName, filterKey);
        } else {
          callMethod(action.methodName);
        }
      }
    }
  }, [editModeCancelConfirm]);

  const beforeSearch = (e, itemName) => {
    {
      let action;
      switch (itemName) {
        //searchByKeyword
        case 'thick':
        case 'unitPrice':
          action = actionArr[1];
          break;
        //材質Id
        case 'materialTypeIq3':
          action = actionArr[4];
          break;
        //表示.非表示
        case 'showFlg':
          action = actionArr[5];
          break;
      }
      setFilterKey(e);
      setDiscardOKAction(action);
      callMethod(action.methodName, e);
    }
    setIsFilterFlg(true);
  };

  // 材質名称で検索した場合、
  const searchByDataState = (value) => {
    dataState === value ? getDataByFilter() : setDataState(value);
  };

  // 表示.非表示で検索した場合、
  const searchByShowFlg = (value) => {
    showFlag === value ? getDataByFilter() : setShowFlag(value);
  };

  // キーワードで検索した場合、
  const searchByKeyword = (e) => {
    switch (e.target.name) {
      case 'toThickness':
        toThickness === e.target.value ? getDataByFilter() : setToThickness(e.target.value);
        break;
      case 'fromThickness':
        fromThickness === e.target.value ? getDataByFilter() : setFromThickness(e.target.value);
        break;
      case 'unitPrice':
        // let formattedValue = formatCurrencyInput(e.target.value);
        unitPriceKey === e.target.value ? getDataByFilter() : setUnitPriceKey(e.target.value);
        break;
    }
  };

  // 絞り込み、
  const getDataByFilter = async () => {
    if (filteredData?.length <= 0) {
      return;
    }
    let nKeyword = nameKeyword;
    let mKeyword = modelKeyword;
    let upperRange = toThickness;
    let lowerRange = fromThickness;
    let unitPriceKeyword = unitPriceKey;
    let currentData = [...filteredData];
    let materialFilterData = currentData;
    let flag;

    // // 名称のキーワードで絞り込み
    // if (unitPriceKeyword != '') {
    //   materialFilterData = materialFilterData?.filter(
    //     (item) => parseFloat(item.info.unitPrice) === parseFloat(unitPriceKeyword)
    //   );
    // }

    // if (lowerRange != '' || upperRange != '') {
    //   lowerRange === '' && (lowerRange = 0);
    //   upperRange === '' &&
    //     (upperRange = Math.max.apply(
    //       null,
    //       materialFilterData?.map(function (o) {
    //         return o?.info.thick;
    //       })
    //     ));
    //   materialFilterData = materialFilterData?.filter(function (obj) {
    //     let objThickness = parseFloat(obj?.info.thick);
    //     return objThickness >= parseFloat(lowerRange) && objThickness <= parseFloat(upperRange);
    //   });
    // }

    // //  無効フラグで絞り込み
    // if (showFlag === 1 || showFlag === 2) {
    //   flag = showFlag === 1 ? true : false;
    //   materialFilterData = materialFilterData?.filter((item) => item.info.isUsed === flag);
    // }

    // //参考価格用材質で絞り込み
    // if (dataState !== undefined && dataState !== '全て') {
    //   materialFilterData = materialFilterData?.filter((item) => item.materialTypeIq3Id === dataState);
    // }

    let filterData = {
      thickStart: fromThickness !== undefined && fromThickness !== '' ? fromThickness : 0,
      thickEnd: toThickness !== undefined && toThickness !== '' ? toThickness : 0,
      unitPrice: unitPriceKey !== undefined && unitPriceKey !== '' ? unitPriceKey : 0,
      materialTypeIq3Id: dataState !== undefined && dataState !== '' && dataState !== '全て' ? dataState : 0,
      isUsedFlg: showFlag,
    };
    setFilterDatas(filterData);
    let materialIQ3Info = await getMaterialIQ3Info(pageSize, 0, ascSortFlg, sortNm, filterData);
    if (materialIQ3Info) {
      materialFilterData = materialIQ3Info ? materialIQ3Info?.data : [];
      setFilteredData(materialFilterData);
      setTotalCount(materialIQ3Info?.totalCount);
    }
    setCurrentPage(1);
    setIsFilterFlg(false);
    props?.updateSelectedRowId(selectedRowKeys, 0, currentPage, ascSortFlg, sortNm, filterData);
  };

  document.body.style.overflowY = 'hidden';

  const reportModalTitle = (
    <div
      style={{
        width: 520,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const setSplitPaneSize = (splitSize) => {
    setSizes(splitSize);
  };

  // 更新確認のOKを押下で、一覧画面のデータを反映する
  const submitData = async (updateData) => {
    var tmpData = [...filteredData];
    var updatedInfo = [];
    props?.loading(true); // Waitingダイアログを表示にする
    updatedInfo = await updateMaterialIq3Data(updateData);

    var index = tmpData?.findIndex((item) => item?.id === updatedInfo?.id);
    tmpData[index] = updatedInfo;
    setMaterialNameData(tmpData);
    setFilteredData(tmpData);
    setTmpFilteredData(tmpData);
    setSelectedRowKeys(updatedInfo?.id);
    setSelectedData(updatedInfo);
    props?.updateSelectedRowId(updatedInfo?.id, 0, currentPage, ascSortFlg, sortNm, filterDatas);
    setIsFilter(false);
    await getMaterialIQ3();
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // 板金子部品材料マスタ情報をDBに更新する
  async function updateMaterialIq3Data(updateData) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'MaterialIq3';
      const otherParam = {
        method: 'PUT',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          id: updateData.id,
          code: updateData.code,
          name: updateData.name,
          materialTypeIq3Id: updateData.materialTypeIq3Id,
          info: updateData.info,
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 重量単価更新の押下
  const handleChangeUnitPrice = async () => {
    let nameData = [...filteredData];
    props?.loading(true); // Waitingダイアログを非表示にする
    for (var i = 0; i <= nameData?.length - 1; i++) {
      let updatedPrice = 0;
      if (plusMinusAct === '+') {
        updatedPrice = parseFloat(nameData[i]?.info.unitPrice) + unitPrice;
      } else if (plusMinusAct === '-') {
        updatedPrice = parseFloat(nameData[i]?.info.unitPrice) - unitPrice;
        if (updatedPrice < 0) {
          updatedPrice = 0;
        }
      }
      nameData[i].info.unitPrice = updatedPrice;
      nameData[i] = await updateMaterialIq3Data(nameData[i]);
    }
    props?.loading(false); // Waitingダイアログを非表示にする
    setFilteredData(nameData);
    setTmpFilteredData(nameData);
    setMaterialNameData(nameData);
    setIsFilter(true);
  };

  // 編集モードを変更
  const updateEditMode = (mode) => {
    setEditMode(mode);
    props.updateMainParameterEditMode(mode);
  };

  const handlePageSizeChange = (current, pagesize) => {
    setPageSize(pagesize);
  };

  // CSVヘッダの情報
  const getCSVHeaderInfo = () => {
    let str = '';
    columns?.map((col) => (str.length === 0 ? (str += col.title) : (str += ',' + col.title))); // ヘッダの情報
    str = 'ID,' + str;
    return str;
  };

  // CSV出力情報
  const getCsvExportData = async () => {
    let str = '';
    str = getCSVHeaderInfo();
    let pageBefore =
      props.initialParam === 'iq3_materialName' && props?.rowSelectPage !== undefined && props?.rowSelectPage !== 0
        ? props?.rowSelectPage - 1
        : 0;
    setCurrentPage(pageBefore === 0 ? 1 : props?.rowSelectPage);
    let propSortFlg =
      props.initialParam === 'iq3_materialName' && props?.ascSortFlg !== undefined ? props?.ascSortFlg : ascSortFlg;
    let propSortNm = props.initialParam === 'iq3_materialName' && props?.sortNm !== undefined ? props?.sortNm : sortNm;
    // let propFilterDatas =
    //   props.initialParam === 'iq3_materialName' && props?.filterDatas !== undefined ? props?.filterDatas : filterDatas;
    // 2025-08-22 IQX_WEBEST-455 材料名称のCSVがちゃんと出力されないバグ
    let propFilterDatas =
      props.initialParam === 'iq3_materialName' &&
      props?.filterDatas &&
      'materialTypeIq3Id' in props.filterDatas &&
      'thickStart' in props.filterDatas &&
      'thickEnd' in props.filterDatas &&
      'unitPrice' in props.filterDatas &&
      'isUsedFlg' in props.filterDatas
        ? props.filterDatas
        : filterDatas;

    let materialNameInfo = await getCSVMaterialIQ3Info(
      totalCount,
      pageBefore,
      propSortFlg,
      propSortNm,
      propFilterDatas
    );
    if (materialNameInfo) {
      let filteredData = materialNameInfo ? materialNameInfo?.data : [];
      filteredData?.map((data, index) => {
        // CSV内容
        str +=
          '\n' +
          data.id +
          ',' +
          (index + 1) +
          ',' +
          data.code +
          ',' +
          data.name +
          ',' +
          getMaterilTypeIQ3Name(data.materialTypeIq3Id) +
          ',' +
          data.info.thick +
          ',' +
          data.info.gravity +
          ',' +
          data.info.unitPrice +
          ',' +
          formatDate(data.created) +
          ',' +
          formatDate(data.modified) +
          ',' +
          data.modifier +
          ',' +
          data.info.remarks +
          ',' +
          data.info.isUsed;
      });
    }
    return str;
  };

  // CSV入力情報
  const submitCsvImportData = async (dataList) => {
    let createdDataInfo = [];
    let failedDatas = [];
    messageRef.current = [];
    let tempDatas = [];
    props?.loading(true); // Waitingダイアログを表示にする
    // ヘッダの情報
    if (JSON.stringify(dataList[0]) !== JSON.stringify(getCSVHeaderInfo())) {
      // 不正なヘッダの情報
      messageRef?.current?.push(<li>{ErrorMessage('1行目').E016}</li>);
    } else {
      for (let i = 1; i < dataList.length; i++) {
        let tempData = {
          code: '',
          name: '',
          materialTypeIq3Id: '',
          priceHistories: [],
          info: { isUsed: true, thick: '', gravity: '', unitPrice: 0, remarks: '' },
        };
        let data = dataList[i].split(',');
        if (data && data?.[0].length === 0) continue;
        if (!csvImportDataValidation(i + 1, data)) {
          failedDatas.push(dataList[i]);
          continue;
        }
        tempData.id = data?.[0];
        tempData.code = data?.[2];
        tempData.name = data?.[3];
        tempData.materialTypeIq3Id = materialTypeIQ3List?.find((item) => item.label === data?.[4])?.value;
        tempData.info.thick = data?.[5];
        tempData.info.gravity = data?.[6];
        tempData.info.unitPrice = data?.[7];
        tempData.info.remarks = data?.[11];
        tempData.info.isUsed = data?.[12] ? JSON.parse(data?.[12]?.toLowerCase()) : true; // IQX_WEBEST-301
        tempDatas.push(tempData);
      }
      let pageBefore =
        props.initialParam === 'iq3_materialName' && props?.rowSelectPage !== undefined && props?.rowSelectPage !== 0
          ? props?.rowSelectPage - 1
          : 0;
      setCurrentPage(pageBefore === 0 ? 1 : props?.rowSelectPage);
      let propSortFlg =
        props.initialParam === 'iq3_materialName' && props?.ascSortFlg !== undefined ? props?.ascSortFlg : ascSortFlg;
      let propSortNm =
        props.initialParam === 'iq3_materialName' && props?.sortNm !== undefined ? props?.sortNm : sortNm;
      let propFilterDatas =
        props.initialParam === 'iq3_materialName' && props?.filterDatas !== undefined
          ? props?.filterDatas
          : filterDatas;
      createdDataInfo = await createMaterialIq3CSV(
        tempDatas,
        pageSize,
        pageBefore,
        propSortFlg,
        propSortNm,
        propFilterDatas
      );
      if (createdDataInfo) {
        let createdDatas = createdDataInfo?.data;
        if (createdDatas !== undefined && createdDatas?.length > 0) {
          setMaterialNameData(createdDatas);
          setFilteredData(createdDatas?.filter((item) => item.info.isUsed === true));
          setTotalCount(createdDataInfo?.totalCount);
          setSelectedRowKeys(createdDatas?.[0]?.id);
          setSelectedData(createdDatas?.[0]);
          props?.updateSelectedRowId(createdDatas?.[0]?.id, 0, 1, ascSortFlg, sortNm, filterDatas);
          setCurrentPage(1);
        }
      }
    }
    Modal.success({
      width: 500,
      className: 'modal-complete csv-modal-complete',
      title: '完了',
      content: (
        <p style={{ fontSize: '13.5px', whiteSpace: 'pre-line', lineHeight: 2 }}>
          {'CSV入力のデータ保存は完了しました。正常：' + tempDatas?.length + '件、異常：' + failedDatas?.length + '件'}
          {messageRef.current?.length > 0 ? (
            <>
              <br></br>
              {'下記の内容をご確認ください。'}
              <br></br>
              <ul>{messageRef.current}</ul>
            </>
          ) : (
            <></>
          )}
        </p>
      ),
    });
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // CSV入力情報チェック
  const csvImportDataValidation = (lineNo, data) => {
    // CSV入力情報チェック
    let no = lineNo + '行目の';

    // コード
    let input = data?.[2];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('コード').E007}</li>);
      return false;
    }

    // 材料名
    input = data?.[3];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('材料名').E007}</li>);
      return false;
    }

    // 材質名称
    input = data?.[4];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('材質名称').E007}</li>);
      return false;
    }

    if (input?.length > 0 && materialTypeIQ3List?.findIndex((item) => item.label === input) === -1) {
      // 不正な材質名称
      messageRef?.current?.push(<li>{no + ErrorMessage('材質名称').E016}</li>);
      return false;
    }

    // 板厚
    input = data?.[5];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('板厚').E007}</li>);
      return false;
    }

    if (input?.length > 0 && !isDecimal(input)) {
      messageRef?.current?.push(<li>{no + ErrorMessage('板厚').E014}</li>);
      return false;
    }

    // 比重
    input = data?.[6];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('比重').E007}</li>);
      return false;
    }

    if (input?.length > 0 && !isDecimal(input)) {
      messageRef?.current?.push(<li>{no + ErrorMessage('比重').E014}</li>);
      return false;
    }

    // 重量単価
    input = data?.[7];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('重量単価').E007}</li>);
      return false;
    }

    if (input?.length > 0 && !isDigit(input)) {
      messageRef?.current?.push(<li>{no + ErrorMessage('重量単価').E009}</li>);
      return false;
    }

    return true;
  };

  // CSV入力ボタンを押下した場合、
  const onClickCSVImport = () => {
    props?.onClickCSVImport();
  };

  // CSV出力ボタンを押下した場合、
  const onClickCSVExport = () => {
    props?.onClickCSVExport();
  };

  return (
    <>
      {/* 一覧とプロパティ表示 */}
      <div
        style={{
          height: '90.8vh',
          marginLeft: 10,
        }}
        className="materialName"
      >
        <SplitPane split="vertical" sizes={sizes} onChange={setSizes} resizerSize={1}>
          <div style={{ marginTop: 7 }}>
            {/*  クイック検索 */}
            <>
              <Space size="middle" className="filterSpace">
                <Select
                  style={{ width: 170 }}
                  onChange={(e) => beforeSearch(e, 'materialTypeIq3')}
                  id="materialRefDDL"
                  name="materialRefDDL"
                  value={dataState}
                  defaultValue={'全て'}
                >
                  <Select.Option id="allOption" value={'全て'}>
                    {'全ての材質名称'}
                  </Select.Option>
                  {materialTypeIQ3List?.map((item, index) => (
                    <Select.Option key={index} id={'materialClassName' + item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>

                <div
                  className="thicknessFilter"
                  size="middle"
                  style={{ gap: 0, display: 'flex', alignItems: 'center' }}
                >
                  <label>板厚：</label>
                  <div className="containerStyle" style={{ border: 0 }}>
                    <Input
                      type="number"
                      className="filter-input-range input-editable search-select-input"
                      onPressEnter={(e) => beforeSearch(e, 'thick')}
                      onBlur={(e) => beforeSearch(e, 'thick')}
                      onKeyPress={(e) => {
                        handleKeyPress(e, false); // IQX_WEBEST-251
                      }}
                      style={{ width: 90 }}
                      allowClear
                      // onChange={(e) => {
                      //   if (e.target.value === '') {
                      //     beforeSearch(e, 'thick');
                      //   }
                      // }}
                      onChange={(e) => {
                        beforeSearch(e, 'thick');
                      }}
                      value={fromThickness}
                      name="fromThickness"
                      id="fromThickness"
                    ></Input>
                    <label>~</label>
                    <Input
                      type="number"
                      className="filter-input-range input-editable search-select-input"
                      onPressEnter={(e) => beforeSearch(e, 'thick')}
                      onBlur={(e) => beforeSearch(e, 'thick')}
                      onKeyPress={(e) => {
                        handleKeyPress(e, false); // IQX_WEBEST-251
                      }}
                      style={{ width: 90 }}
                      allowClear
                      // onChange={(e) => {
                      //   if (e.target.value === '') {
                      //     beforeSearch(e, 'thick');
                      //   }
                      // }}
                      onChange={(e) => {
                        beforeSearch(e, 'thick');
                      }}
                      value={toThickness}
                      name="toThickness"
                      id="toThickness"
                    ></Input>
                  </div>
                </div>

                <Input
                  className="input-editable search-select-input unitPrice"
                  placeholder="重量単価"
                  allowClear
                  type="number"
                  // pattern="[0-9]*"
                  onPressEnter={(e) => beforeSearch(e, 'unitPrice')}
                  onBlur={(e) => beforeSearch(e, 'unitPrice')}
                  onKeyPress={(e) => {
                    handleKeyPress(e, false);
                  }}
                  // onChange={(e) => {
                  //   if (e.target.value === '') {
                  //     beforeSearch(e, 'unitPrice');
                  //   }
                  // }}
                  onChange={(e) => {
                    beforeSearch(e, 'unitPrice');
                  }}
                  value={unitPriceKey}
                  name="unitPrice"
                  id="unitPrice"
                />

                <Select
                  style={{ width: 90 }}
                  onChange={(e) => beforeSearch(e, 'showFlg')}
                  placeholder="表示・非表示"
                  id="showFlgDrop"
                  name="showFlgDrop"
                  value={showFlag}
                >
                  {dataStateList?.map((item, index) => (
                    <Select.Option key={index} id={'showFlg' + item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Space>
              <Space className="unitPriceAction" size="middle" style={{ gap: 0, position: 'absolute', right: 0 }}>
                <label>重量単価更新：</label>
                <div className="containerStyle">
                  <Select
                    defaultValue={'+'}
                    id="plusMinusDDL"
                    name="plusMinusDDL"
                    className={plusMinusAct === '-' ? 'plusMinusDDL minus' : 'plusMinusDDL'}
                    value={plusMinusAct}
                    onChange={(e) => {
                      setPlusMinusAct(e);
                    }}
                  >
                    {plusMinus?.map((item, index) => (
                      <Select.Option key={index} id={'plusMinus' + item.value} value={item.label}>
                        {item.label}
                      </Select.Option>
                    ))}
                  </Select>
                  <CurrencyInput
                    name="unitPrice"
                    id="unitPrice"
                    style={{ width: 80, border: 'none', textAlign: 'center' }}
                    value={unitPrice}
                    type="text"
                    prefix="¥"
                    decimalsLimit={100}
                    className="currencyInput"
                    onValueChange={(e) =>
                      setUnitPrice(() => {
                        let value = e;
                        let formattedValue = value;

                        if (e == '' || e === undefined) {
                          formattedValue = 0;
                        } else {
                          if (value.startsWith('¥', 0)) {
                            formattedValue = formattedValue.replace('¥', '');
                          }
                        }
                        return parseFloat(formattedValue);
                      })
                    }
                  />
                </div>
                <SyncOutlined className="submitUnitPrice" style={{ margin: '0 5' }} onClick={handleChangeUnitPrice} />
              </Space>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 10 }}>
                <Table
                  showSorterTooltip={false}
                  columns={hasCheckData ? tableColumns : chkData}
                  components={components}
                  dataSource={filteredData}
                  // scroll={{ y: 590, x: '10vw' }}
                  scroll={{ y: tableScrollY, x: 'max-content' }}
                  rowClassName={(record) => (record.id == selectedRowKeys ? 'active-row' : 'data-row')}
                  rowKey={(record) => record.id}
                  pagination={{
                    position: ['bottomLeft'],
                    total: totalCount,
                    showTotal: (total, range) => `全${total}件中${range[0]}件〜${range[1]}件を表示`,
                    // defaultPageSize: 25,
                    defaultCurrent: 1,
                    // pageSize: 25,
                    current: currentPage,
                    pageSize: pageSize,
                    pageSizeOptions: pageSizes,
                    showSizeChanger: true,
                    onShowSizeChange: handlePageSizeChange,
                    onChange: (page) => {
                      setCurrentPage(page);
                    },
                  }}
                  // className="param_tbListShow"
                  onRow={(record, index) => {
                    return {
                      onClick: (event) => {
                        onRowSelect(record, index);
                      },
                    };
                  }}
                  onChange={handleTableChange}
                  loading={tblLoading}
                />
              </Row>
            </>
          </div>
          <div>
            {/* <Outlet /> */}
            <Routes>
              <Route
                exact
                path=":iq3.materialName"
                element={
                  <MaterialNameDetail
                    ref={detailRef}
                    editMode={editMode}
                    // selectedData={materialNameData?.find((element) => element.id === selectedRowKeys)}
                    selectedData={selectedData}
                    itemNo={itemNo}
                    submitData={submitData}
                    materialTypeIQ3List={materialTypeIQ3List}
                    getMaterilTypeIQ3Name={getMaterilTypeIQ3Name}
                    updateEditMode={updateEditMode}
                    getAntInputBoxClassName={getAntInputBoxClassName}
                    showEdtConfirmOK={showEdtConfirmOK}
                    showEdtConfirmCancle={showEdtConfirmCancle}
                  />
                }
              />
            </Routes>
          </div>
        </SplitPane>
      </div>

      {/* 一括編集　Modal */}
      {visibleGroupEditModal &&
        commonModal(
          visibleGroupEditModal,
          modalTitle('材料名称（選択したデータをまとめて編集）', 1790, -24),
          null,
          null,
          1790,
          handleOk,
          handleCancel,
          gpEditModalContent,
          'gpEditModal',
          null,
          true
        )}

      {/* 削除_Modal */}
      {visibleDeleteModal &&
        commonResponsiveConfirmModal(
          visibleDeleteModal,
          confirmModalTitle,
          commonDeleteFooter(deleteOK, deleteCancel),
          null,
          400,
          handleOk,
          handleCancel,
          confirmDeleteContent,
          null,
          null,
          false
        )}

      {/* XML呼出 */}
      <Modal
        //title="確認"
        title={reportModalTitle}
        open={visibleXMLInput}
        onOk={handleOkXMLInput}
        onCancel={handleCancel}
        footer={[
          <Button key="file" type="primary" onClick={handleOkXMLInput} className="btn-ok-cancel">
            OK
          </Button>,
          <Button key="back" onClick={handleCancel} className="btn-ok-cancel">
            Cancel
          </Button>,
        ]}
        closeIcon={<CloseOutlined style={{ color: 'white' }} />}
      >
        <p>
          装置情報（時間チャージ、段取設定、加工設定）を初期パラメータ作成情報から取り込みます。
          <br></br>装置情報は、呼出情報で更新されます。
        </p>
      </Modal>

      {/** 編集中破棄確認ポップアップ */}
      {editModeCancelConfirm
        ? commonResponsiveConfirmModal(
            editModeCancelConfirm,
            confirmModalTitle,
            commonFooter(discardConfirmOk, discardConfirmCancel),
            null,
            400,
            discardConfirmOk,
            discardConfirmCancel,
            confirmHakiContent,
            null,
            null,
            false
          )
        : ''}

      {/* 新規追加Modal */}
      {visibleAddNewModal
        ? commonModal(
            visibleAddNewModal,
            modalTitle('材料名称（新規追加）', 800, -24),
            // 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
            // 編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
            // 破棄の表記ではなく「戻る」や「終了」にするのはどうか
            // commonActionFooter(addOK, addCancel, '登録', '破棄'),
            commonActionFooter(addOK, addCancel, '登録', '戻る'),
            null,
            800,
            handleOk,
            handleCancel,
            addModalContent,
            'addNewMaterialClassModal',
            null,
            false
          )
        : ''}

      {/** 新規追加破棄確認ポップアップ */}
      {updateCancelConfirm &&
        commonResponsiveConfirmModal(
          updateCancelConfirm,
          confirmModalTitle,
          commonFooter(isAdd ? updConfirmOk : updCancelOK, isAdd ? updConfirmCancel : updCancelCancel),
          null,
          400,
          updCancelOK,
          updCancelCancel,
          isAdd ? (visibleGroupEditModal ? confirmUpdateContent : confirmCreateContent) : confirmDiscardContent,
          null,
          null,
          false
        )}

      {/* 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい */}
      {isBulkDelete && (
        <BulkDeleteModal
          isOpen={isBulkDelete}
          title={bulkDeleteModalTitle}
          loading={bulkDeleteLoading}
          data={filteredData}
          deleteRowSelection={deleteRowSelection}
          tableColumns={tableColumns}
          page={currentPage}
          pageSize={pageSize}
          totalCount={totalCount}
          handlePageChange={(page) => setCurrentPage(page)}
          handleSelectAll={handleSelectAll}
          bulkDeleteOk={bulkDeleteOk}
          bulkDeleteCancel={bulkDeleteCancel}
          setDeleteSelectedRowKeys={setDeleteSelectedRowKeys}
        />
      )}

      {isDeleteAll && (
        <Modal
          maskClosable={false}
          open={isDeleteAll}
          title={deleteModalTitle}
          footer={commonDeleteAllFooter(deleteAllRecord, deleteAllCancel)}
          width={400}
          onOk={deleteAllRecord}
          onCancel={deleteAllCancel}
          closeIcon={<CloseOutlined style={{ color: 'white' }} />}
          centered={false}
          modalRender={(modal) => (
            <Draggable handle=".ant-modal-header">
              <div>{modal}</div>
            </Draggable>
          )}
        >
          <div>
            <p style={{ fontSize: '13px', marginBottom: '20px' }}>すべてのデータを削除しますがよろしいですか。</p>
          </div>
        </Modal>
      )}
    </>
  );
});

export default MaterialNameList;
